module.exports = __webpack_public_path__ + "static/media/loginMan.62b23007.jpg";